<div class="batch-starter">
  <div class="title">
    <h2>Batch</h2>
  </div>

  <form [formGroup]="form" class="batch-form">
    <mat-form-field class="operation-field">
      <mat-label>Opération</mat-label>
      <mat-select formControlName="operation" (selectionChange)="onOperationSelected($event.value)">
        @for (operation of availableOperations; track operation.id) {
          <mat-option [value]="operation.id">{{ operation.description }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="textareas">
      <div class="textarea-block">
        <mat-form-field class="full-width">
          <mat-label>Groupes cibles (1 ligne par groupe ID)</mat-label>
          <textarea matInput formControlName="targetGroups" rows="12"></textarea>
        </mat-form-field>
        <div class="group-count">Groupes concernés {{ targetGroupsCount }}</div>
      </div>

      <div class="textarea-block">
        <mat-form-field class="full-width">
          <mat-label>Paramètres optionnels (JSON)</mat-label>
          <textarea matInput formControlName="parameters" rows="12"></textarea>
        </mat-form-field>
      </div>
    </div>

    <mat-checkbox formControlName="dryRun">Mode dry-run</mat-checkbox>

    <div class="actions">
      <button mat-flat-button color="primary" type="button" [disabled]="isExecuting()" (click)="execute()">Exécuter</button>
      @if (isExecuting()) {
        <mat-spinner [diameter]="24"></mat-spinner>
      }
    </div>

    <mat-form-field class="full-width">
      <mat-label>Résultats de l'exécution</mat-label>
      <textarea matInput readonly rows="12" [value]="results()"></textarea>
    </mat-form-field>
  </form>
</div>
